import { render, staticRenderFns } from "./HomeTopic.vue?vue&type=template&id=6534dbd3&scoped=true"
import script from "./HomeTopic.vue?vue&type=script&lang=js"
export * from "./HomeTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534dbd3",
  null
  
)

export default component.exports